export const getNumbersFromString = (string, includeDotSeparator = false) => {
    if (typeof string !== 'string') {
        return ''
    }

    let numbers = includeDotSeparator
        ? string.match(/\d+(\.\d+)?/g)
        : string.match(/\d+/g);

    if (numbers) {
        return numbers.join("");
    }
    return ''
}

export const numbersLengthFromString = (string, includeDotSeparator = false) => {
    const numbers = getNumbersFromString(string, includeDotSeparator);

    return numbers.length
        ? numbers.length
        : 0
}

export const fieldsAreFilled = (...args) => {
    return args.every(el => !!el?.length)
}

export const matchesEmailRegex = (string) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(string);
}

export const commafy = (num) => {
  var str = num.toString().split('.');
  if (str[0].length >= 5) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}
